import { motion } from "framer-motion";
import { Reveal, SectionHead } from "./Reveal";

const people = [
  { id: "architektin", name: "Sanaz Gholizad", role: "Architektin", img: "/img/sanaz.jpg", text: "Plant Räume, in denen Menschen gerne arbeiten. Verantwortet Raumkonzept, Gestaltung und Umbau.", tags: ["Raumplanung", "New Work", "Umbau"] },
  { id: "it", name: "Ghassem Azari", role: "IT-Spezialist", img: "/img/ghassem.jpg", text: "Modernisiert IT-Landschaften im Mittelstand. Verantwortet Infrastruktur, Sicherheit und Dokumentation.", tags: ["Infrastruktur", "Cloud", "Security"] },
];

const Person = ({ p, i }) => (
  <Reveal delay={i * 0.15} className={i === 1 ? "md:mt-32" : ""}>
    <motion.div data-testid={`founder-${p.id}`} className="group" initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
      <motion.div
        variants={{ hidden: { clipPath: "inset(0% 0% 100% 0%)" }, show: { clipPath: "inset(0% 0% 0% 0%)", transition: { duration: 1.3, ease: [0.22, 1, 0.36, 1] } } }}
        className="relative aspect-[4/5] overflow-hidden rounded-[2px] bg-[var(--stone-2)]"
      >
        <img src={p.img} alt={`${p.name}, ${p.role}`} className="h-full w-full object-cover object-[50%_20%] grayscale transition-[filter,transform] duration-1000 group-hover:scale-[1.03] group-hover:grayscale-0" />
        <div className="blueprint pointer-events-none absolute inset-0 opacity-60" />
      </motion.div>
      <div className="mt-6 flex items-baseline justify-between border-b border-[var(--line)] pb-4">
        <h3 className="font-serif-d text-3xl sm:text-4xl" data-testid={`founder-${p.id}-name`}>{p.name}</h3>
        <span className="eyebrow">{p.role}</span>
      </div>
      <p className="mt-4 max-w-md text-base leading-relaxed text-[var(--ink-2)]">{p.text}</p>
      <p className="font-mono-d mt-4 text-xs uppercase tracking-wider text-[var(--ink-2)]">{p.tags.join(" · ")}</p>
    </motion.div>
  </Reveal>
);

export const Founders = () => (
  <section id="team" data-testid="founders-section" className="border-t border-[var(--line)] bg-[var(--stone-2)]/60">
    <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-40">
      <SectionHead
        id="team"
        eyebrow="04 — Wer wir sind"
        title={["Ein Paar. Eine Architektin,", <span key="i" className="italic text-[var(--clay)]">ein IT-Spezialist.</span>]}
        intro="Wir haben gemerkt: Bei Unternehmensnachfolgen werden Räume und IT meist getrennt gedacht – oder gar nicht. Gemeinsam planen wir beides aus einer Hand, damit Ihr Unternehmen als Ganzes überzeugt."
      />
      <div className="mt-16 grid gap-16 md:grid-cols-2 md:gap-10 lg:mt-24 lg:gap-24 lg:px-[8%]">
        {people.map((p, i) => <Person key={p.id} p={p} i={i} />)}
      </div>
    </div>
  </section>
);
